export const parseDisplayUserName = (displayName = "") => {
  const fstSpaceIndex = displayName.indexOf(" ");

  if (fstSpaceIndex < 0) {
    return { firstName: displayName, lastName: "" };
  }

  const firstName = displayName.slice(0, fstSpaceIndex);
  const lastName = displayName.slice(fstSpaceIndex + 1);

  return { firstName, lastName };
};
